import { listApi } from './service';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';
import { goBack } from '@/utils/bridge';

export interface TopicListType {
  data: {
    id: number;
    number: number;
    paper: {
      duration: number;
      id: number;
      number: number;
      paper_id: string;
      title: string;
    };
    paper_id: string;
    subject_id: number;
    type: number;
  }[];
  type: number;
}

export interface ModelType {
  namespace: string;
  state: TopicListType;
  effects: {
    fetch: Effect;
  };
  reducers: {
    save: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'topicList',

  state: {
    data: [],
    type: 0,
  },

  effects: {
    *fetch({ callback, payload }, { call, put }) {
      const response = yield call(listApi, payload);
      if (response && response.error_code === 0) {
        yield put({
          type: 'save',
          payload: {
            ...response,
            type: payload.type,
          },
        });
      } else if (
        response &&
        response.error_code > 0 &&
        response &&
        response.error_code < 1007
      ) {
        goBack();
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload.data,
        type: payload.type,
      };
    },
  },
};

export default Model;
